<template>
  <component :is="tag" v-bind="$attrs">
    <span @click.stop="open = !open">
      <slot>
      </slot>
    </span>
    <v-datepicker-modal
      v-model="open"
      :date="value"
      @click.native.stop=""
      @change="$emit('input', $event)"
      :tag="datePickerComponent">
    </v-datepicker-modal>
  </component>
</template>

<script>
import VDatepickerModal from '@/components/base/VDatepickerModal'

export default {
  props: {
    value: {
      type: Date
    },
    tag: {
      type: String,
      default: 'span'
    },
    hasTime: {
      type: Boolean,
      default: false
    }
  },
  components: { VDatepickerModal },
  data() {
    return {
      open: false
    }
  },
  computed: {
    datePickerComponent() {
      return this.hasTime ? 'VDatetimepicker' : 'VDatepicker'
    }
  }
}
</script>